let _formatTimeSection = (value, delimiter, leadingZeros) => {
	var valueStr = "";

	if (leadingZeros) {
		valueStr = (value < 10 ? '0' : '') + String(value);
	}
	else if (value > 0) {
		valueStr = String(value);
	}

	if (valueStr.length > 0) {
		valueStr += delimiter ? delimiter : "";
	}

	return valueStr;
};

// duration is in seconds
export const formatDuration = (duration, delimiter, leadingZeros, keepZeros = false, excludeSeconds = false, abbrevUnits) => {
	let result = null;

	if (isNaN(duration)) {
		return null;
	}

	if (duration || duration === 0) {
		// can use << 0 instead of Math.floor, implicit cast to int. Faster?
		let x = duration; // Math.floor(duration / 1000);
		const seconds = Math.round(x % 60);
		x = Math.floor(x / 60);
		const minutes = x % 60;
		x = Math.floor(x / 60);
		const hours = x % 24;
		x = Math.floor(x / 24);
		// var days = x;

		//Logger.log("time.js", "formatDuration()", duration, days, hours, minutes, seconds);

		result = "";
		let hoursStr = "";
		if (hours > 0 || keepZeros) {
			let hoursDelimiter = delimiter ? delimiter : (abbrevUnits ? "h" : "hr ");
			hoursStr = _formatTimeSection(hours, hoursDelimiter, keepZeros);
		}

		result += hoursStr;

		const minutesDelimiter = delimiter ? delimiter : (abbrevUnits ? "m" : "min ");
		const minutesStr = _formatTimeSection(minutes, minutesDelimiter, (hours > 0 ? true : leadingZeros || keepZeros));

		result += minutesStr;

		let secondsStr = "";
		if (!excludeSeconds) {
			const secondsDelimiter = delimiter ? null : (abbrevUnits ? "s" : "sec ");
			secondsStr = _formatTimeSection(seconds, secondsDelimiter, true);
		}

		result += secondsStr;
	}

	return result;
};



// WEBPACK FOOTER //
// ./src/functions/time.js